module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_2_2_1.c9b611ee.png";